import type { ReactNode } from "react";
import { Link, NavLink } from "react-router-dom";
import ThemePlayground from "./ThemePlayground";

interface SiteLayoutProps {
  children: ReactNode;
}

/** Provides keyboard-accessible shared navigation, page framing, development-only color controls, and footer content for the portfolio. */
export default function SiteLayout({ children }: SiteLayoutProps) {
  return (
    <div className="site-shell">
      <a className="skip-link" href="#main-content">
        Skip to main content
      </a>
      <header className="site-header">
        <Link
          className="brand"
          to="/"
          aria-label="Mason Cleland portfolio home"
        >
          <span className="brand-mark">MC</span>
        </Link>
        <nav aria-label="Primary navigation">
          <NavLink to="/" end>
            Home
          </NavLink>
          <a href="/#projects">Projects</a>
          <NavLink to="/resume">Resume</NavLink>
          <a
            href="https://github.com/Gizmo8095"
            target="_blank"
            rel="noreferrer"
          >
            GitHub
          </a>
        </nav>
      </header>
      <main id="main-content" tabIndex={-1}>
        {children}
      </main>
      <footer className="site-footer">
        <div>
          <strong>Mason Cleland</strong>
          <p>Software, systems, automation, and product integration.</p>
          <small>
            Decorative SVG references adapted from
            AKwasTaken/AKwasTaken.github.io with attribution.
          </small>
        </div>
        <a href="https://github.com/Gizmo8095" target="_blank" rel="noreferrer">
          github.com/Gizmo8095 ↗
        </a>
      </footer>
      {import.meta.env.DEV && <ThemePlayground />}
    </div>
  );
}
